import React, { FC, useMemo } from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import Benefits from '~/modules/feature-access/components/Benefits';
import IntroAnimation from '~/modules/feature-access/components/IntroAnimation';
import { IntroAnimationVariant } from '~/modules/feature-access/components/IntroAnimation/types';
import { getBenefitsList } from '~/modules/feature-access/helpers';
import { FeatureKey, FeatureModule } from '~/modules/feature-access/policy';
import projectConfig from '~/projects/config';
import { Typographies } from '~/theme/typography';

import styles from './styles.module.scss';

type Props = {};

const DetectorReport: FC<Props> = () => {
  const { t } = useTranslation();

  const benefits = useMemo(() => {
    return getBenefitsList(t)
      .filter(
        (el) =>
          !(
            el.key === FeatureKey.DETECTOR_DETAILED_REPORT &&
            el.module === FeatureModule.AI_CONTENT_DETECTOR
          ),
      )
      .sort(
        (a, b) =>
          Number(b.module === FeatureModule.AI_CONTENT_DETECTOR) -
          Number(a.module === FeatureModule.AI_CONTENT_DETECTOR),
      );
  }, []);

  return (
    <div className={styles.container}>
      <Typography
        variant={Typographies.TITLE_LARGE}
        component="div"
        className={styles.title}
      >
        {t('modal:feature_unlock.detector_report_title', {
          project: projectConfig.getProjectName(),
          defaultValue:
            'Upgrade to {{project}} Unlimited To Get Detailed AI Detection Reports',
        })}
      </Typography>

      <div className={styles.animation}>
        <IntroAnimation variant={IntroAnimationVariant.DETECTOR_REPORT} />
      </div>

      <Typography
        variant={Typographies.LABEL_LARGE}
        component="div"
        className={styles.subtitle}
      >
        {t(
          'modal:feature_unlock.detector_report_subtitle',
          'Your digital proof of academic integrity',
        )}
      </Typography>

      <Benefits benefits={benefits} />
    </div>
  );
};

export default DetectorReport;
